import React, { useEffect } from 'react';

import { useGroupJobProspectsState, useGroupJobProspectsActions } from './GroupJobProspectsContext';

import GroupJobProspectsLoader from './GroupJobProspectsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import GroupJobProspectsTable from './GroupJobProspectsTable';
import ClosedJobModal from './ClosedJobModal';
import GenerateResumeBetaModal from './GenerateResumeBetaModal';
import styles from './GroupJobProspects.module.scss';

const GroupJobProspectsContent = () => {
  const state = useGroupJobProspectsState();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
      </div>
    );
  }

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        {state?.group?.path && (
          <a href={state?.group?.path || ''} style={{ fontSize: '20px', color: '#007753', textDecoration: 'none' }}>
            &lt; Back to Group
          </a>
        )}
        <PageTitle text={'Group Job Prospects'} />
        <GroupJobProspectsTable />
      </Stack>
      <ClosedJobModal />
      <GenerateResumeBetaModal />
    </div>
  );
};

const GroupJobProspects = ({ groupId }) => {
  const { initializeState } = useGroupJobProspectsActions();

  useEffect(() => {
    if (groupId) {
      initializeState(groupId);
    }
  }, [groupId]);

  return (
    <>
      <GroupJobProspectsLoader />
      <GroupJobProspectsContent />
    </>
  );
};

export default GroupJobProspects;
